import React, { useEffect, useState } from "react";
import "./PersonalInfo.scss";
import TextInput from "Components/TextInput/TextInput";
import { AnimatePresence, motion } from "framer-motion";
import DropdownInput from "Components/DropDownInput/DropDownInput";
import { countries } from "lib/data";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "Components/ui/skeleton";
import UseInnerWidth from "hooks/UseInnerWidth";
import { Button } from "Components/ui/button";
import { editUser } from "../../../../Redux/Profile/ProfileActions";
import { useAuth } from "@clerk/clerk-react";

function PersonalInfo({ data, setData }) {
  const { user, getUserLoading } = useSelector((state) => state.ProfileReducer);

  const { getToken } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object?.keys(user)?.length > 0) {
      setData({
        firstName: user?.firstName,
        lastName: user?.lastName,
        title: user?.title,
        phone: user?.phone,
        email: user?.email,
        country: user?.country,
        city: user?.city,
        street: user?.street,
        postalCode: user?.postalCodeCode,
      });
    }
  }, [user]);

  // useEffect(() => {
  //   if (
  //     data?.firstName !== user?.firstName ||
  //     data?.lastName !== user?.lastName ||
  //     data?.title !== user?.title ||
  //     data?.phone !== user?.phone ||
  //     data?.email !== user?.email ||
  //     data?.country !== user?.country ||
  //     data?.city !== user?.city ||
  //     data?.street !== user?.street ||
  //     data?.postalCode !== user?.postalCodeCode
  //   ) {
  //     setFound(true);
  //   } else {
  //     setFound(false);
  //   }
  // }, [data]);

  const width = UseInnerWidth();

  return (
    <AnimatePresence initial={true} mode="wait">
      <motion.form
        exit={{
          opacity: 0,
          x: -100,
        }}
        initial={{
          opacity: 0,
          x: -100,
        }}
        animate={{
          opacity: 1,
          x: 0,
        }}
        className={`bg-background-card rounded-lg p-8 relative ${
          !getUserLoading &&
          (width < 768 ? "grid grid-cols-1 gap-6" : "grid grid-cols-3 gap-6")
        }`}
      >
        {getUserLoading ? (
          <div
            className={`${
              width < 768 ? "grid grid-cols-1" : "grid grid-cols-3"
            } w-full gap-6`}
          >
            {Array.from({ length: 9 }).map((_, i) => (
              <div className="space-y-2" key={i}>
                <Skeleton className="h-4 w-1/3" />
                <Skeleton className="h-10 w-full  rounded-md" />
              </div>
            ))}
          </div>
        ) : (
          <>
            <TextInput
              label="First Name"
              required={true}
              placeholder="John"
              type="text"
              value={data.firstName}
              onChange={(e) => setData({ ...data, firstName: e.target.value })}
            />
            <TextInput
              label="Last Name"
              required={true}
              placeholder="Doe"
              type="text"
              value={data.lastName}
              onChange={(e) => setData({ ...data, lastName: e.target.value })}
            />
            <DropdownInput
              label={"Title"}
              required={true}
              placeholder={"Select Title"}
              value={data.title}
              setValue={(value) => setData({ ...data, title: value })}
              data={[
                { label: "Mr", value: "MR" },
                { label: "Mrs", value: "MRS" },
                { label: "Ms", value: "MISS" },
                { label: "Dr", value: "DR" },
                { label: "Prof", value: "PROF" },
              ]}
              key={"country"}
            />
            <TextInput
              label="Phone Number"
              required={true}
              placeholder="xxx-xxx-xxxx"
              type="number"
              value={Number(data.phone)}
              onChange={(e) =>
                setData({ ...data, phone: "+" + e.target.value })
              }
            />
            <TextInput
              label="Email Address"
              required={true}
              placeholder="john.doe@gmail.com"
              type="email"
              disabled={true}
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
            <DropdownInput
              label={"Country"}
              required={true}
              placeholder={"Select Country"}
              value={data.country}
              setValue={(value) => setData({ ...data, country: value })}
              data={countries}
              key={"country"}
            />
            <TextInput
              label="City"
              required={true}
              placeholder="Enter City"
              type="text"
              value={data.city}
              onChange={(e) => setData({ ...data, city: e.target.value })}
            />
            <TextInput
              label="Street"
              required={true}
              placeholder="Enter Street"
              type="text"
              value={data.street}
              onChange={(e) => setData({ ...data, street: e.target.value })}
            />
            <TextInput
              label="Postal Code"
              required={true}
              placeholder="Enter Postal Code"
              type="number"
              value={Number(data.postalCode) || null}
              onChange={(e) =>
                setData({ ...data, postalCode: Number(e.target.value) })
              }
            />
          </>
        )}

        <Button
          className={`${width >= 768 && "col-span-full ml-[auto]"}   mt-4`}
          type="button"
          disabled={
            !(
              data?.firstName !== user?.firstName ||
              data?.lastName !== user?.lastName ||
              data?.title !== user?.title ||
              data?.phone !== user?.phone ||
              data?.email !== user?.email ||
              data?.country !== user?.country ||
              data?.city !== user?.city ||
              data?.street !== user?.street ||
              data?.postalCode !== user?.postalCodeCode
            )
          }
          onClick={() =>
            dispatch(
              editUser(
                {
                  firstName: data?.firstName,
                  lastName: data?.lastName,
                  title: data?.title,
                  phone: data?.phone,
                  country: data?.country,
                  city: data?.city,
                  street: data?.street,
                  postalCode: data?.postalCode,
                },
                getToken
              )
            )
          }
        >
          Save Changes
        </Button>
      </motion.form>
    </AnimatePresence>
  );
}

export default PersonalInfo;
